import NProgress from "nprogress";
import {
  GetStockOutBySendId,
  GetThirdStockOutBySendId
} from "@api/sendGoodsApi.js";
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from "utils";
import {
  GetParmConfig,
  ParmConfigDel,
  ParmConfigAdd
} from "@api/commonApi.js";
import {
  ERP_StockOutAdd,
  LoadThirdStockOutByIdForUpdate,
  ERP_StockOutUpdate
} from "@api/stockOutApi.js";
import $http from "$http";

module.exports = {
  data() {
    return {
      loading: false,
      dialogImageUrl: "",
      PictureVisible: false,
      IsUpdate: false,
      Form: {
        ApplyPic: []
      }, //查看内容
      mapDsj: new Object(), //map:电视机机型
      dsjTypeList: [], //list:电视机机型
      Logistics: [], //物流
      SendGood: "",
      NumShow: false,
      visibleShow: false, //物流弹窗
      dialogContent: "",
      AddForm: {
        SendId: "", //编号3
        LogisticsCode: "", //快递单号
        LogisticsId: "", //快递类型
        GoodsList: [],
        GiftsList: [],
        PackageNum: 0,
        type: "0", //非智趣互联
        Remark: ""
      },
      OrderInfo: {}
    };
  },
  watch: {
    dsjTypeList: {
      deep: true,
      handler() {}
    }
  },
  computed: {
    getDsjTypeList() {},
    isShowIsFirst() {
      if (this.Form.IsFirst > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    viewSure() {
      window.history.go(-1);
    },
    LookPicture(Url) {
      this.dialogImageUrl = Url;
      this.PictureVisible = true;
    },
    getMapDsj(list) {},
    getTCinfo(list) {
      let str = [];
      const h = this.$createElement;
      list.forEach(function (value) {
        //str+=`<p>|--商品:${value.ProName}  数量:+${value.Num}</p>`;
        str.push(
          h(
            "p", {
              style: "font-size:14px;padding-bottom:10px;font-weight:bold;"
            },
            `商品:${value.ProName}  数量:${value.Num}`
          )
        );
      });

      this.$msgbox({
        title: "套餐详情",
        message: h("p", null, str),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(action => {});
    },
    showDialog() {
      this.visibleShow = true;
    },
    dialogClosed() {
      this.dialogContent = "";
      this.visibleShow = false;
    },
    delLogistics(item) {
      let para = {
        Ids: item.Id
      };
      ParmConfigDel(para).then(res => {
        util.doResult(this, res, () => {
          this.getLogistics();
          for (var i = 0; i < this.Logistics.length; i++) {
            if (this.Logistics[i].Id == item.Id) {
              this.AddForm.LogisticsId = "";
            }
          }
        });
      });
    },
    addLogistics() {
      var para = {
        ParmType: 10,
        ParmName: this.dialogContent
      };
      ParmConfigAdd(para).then(res => {
        util.doResult(this, res, () => {
          this.getLogistics("1");
          this.dialogContent = "";
          this.visibleShow = false;
        });
      });
    },
    SendStatus(val) {
      if (val == "全部发货") {
        this.NumShow = true;
        for (var i = 0; i < this.Form.ListGoods.length; i++) {
          this.Form.ListGoods[i].ActualNum = this.Form.ListGoods[i].Num;
        }
      } else {
        this.NumShow = false;
      }
    },
    submitForm() {
      this.AddForm.GoodsList = [];
      this.AddForm.GiftsList = [];
      this.AddForm.SendId = this.$route.query.Id;
      this.loading = true;
      if (this.Form.ListGoods.length > 0) {
        for (var i = 0; i < this.Form.ListGoods.length; i++) {
          var a = {};
          a.ProId = this.Form.ListGoods[i].ProductId;
          a.ProNum = this.Form.ListGoods[i].ActualNum;
          this.AddForm.GoodsList.push(a);
        }
      }


      var flag = util.checkForm({
        ele: this,
        rules: [{
          name: "包裹件数",
          value: this.AddForm.PackageNum,
          required: true,
          isNumber: true,
          more0: true
        }]
      });

      if (!flag) {
        return;
      }

      if (this.IsUpdate == true) {
        this.AddForm.StockOutId = this.$route.query.StockOutId;
        this.AddForm.SendId = this.Form.SendId;
        ERP_StockOutUpdate(this.AddForm).then(res => {
          this.loading = false;
          util.doResult(this, res, () => {

            this.$notify({
              title: "成功",
              message: "更新出库单成功",
              type: "success"
            });
            window.history.go(-1);
          });
        });
      } else {
        $http.post("api/StockOut/StockOutAddV3", this.AddForm).then(res => {
          this.loading = false;
          util.doResult(this, res, () => {
            this.$notify({
              title: "成功",
              message: "生成出库单成功",
              type: "success"
            });
            window.history.go(-1);
          });
        });
        // ERP_StockOutAdd(this.AddForm).then(res => {
        //   this.loading = false;
        //   util.doResult(this, res, () => {

        //     this.$notify({
        //       title: "成功",
        //       message: "生成出库单成功",
        //       type: "success"
        //     });
        //     window.history.go(-1);
        //   });
        // });
      }
    },
    getLogistics(type) {
      let _session = util.getSessin();
      let para = {
        Sid: _session[0],
        Session: _session[1],
        ParmType: 10
      };
      GetParmConfig(para).then(res => {
        this.loading = false;
        util.doResult(this, res, () => {
          this.Logistics = res.data.Data;

          if (type == "1") {
            this.AddForm.LogisticsId = this.Logistics[
              this.Logistics.length - 1
            ].Id;
            this.AddForm.LogisticsId = this.Logistics[
              this.Logistics.length - 1
            ].Id;
          }
        });
      });
    },
    getList1() {
      for (var key in this.mapDsj) {
        this.dsjTypeList.push(this.mapDsj[key]);
      }
    }
  },
  created: function () {
    let _session = util.getSessin();
    let a = {
      Sid: _session[0],
      Session: _session[1],
      ParmType: 10
    };

    GetParmConfig(a).then(res => {
      util.doResult(this, res, () => {
        this.Logistics = res.data.Data;
        if (
          this.$route.query.Id != undefined &&
          this.$route.query.Sid != undefined &&
          this.$route.query.Session != undefined
        ) {
          let para = {
            Sid: _session[0],
            Session: _session[1],
            SendId: this.$route.query.Id
          };
          $http
            .get("api/UserSendGoods/GetStockOutBySendId", para)
            .then(res => {
              let {
                Data,
                Cnt
              } = res.data;
              this.loading = false;
              util.doResult(this, res, () => {
                this.Form = Data
                this.OrderInfo = Data.OrderInfo
              });
            });
        }

        if (this.$route.query.StockOutId !== undefined) {
          this.IsUpdate = true;
          let para = {
            Sid: _session[0],
            Session: _session[1],
            Id: this.$route.query.StockOutId
          };

          $http
            .get("api/UserStockOut/LoadStockOutByIdForUpdate", para)
            .then(res => {
              let {
                Data,
                Cnt
              } = res.data;
              this.loading = false;
              util.doResult(this, res, () => {
                this.Form = Data;
                this.OrderInfo = Data.OrderInfo
                this.AddForm.LogisticsCode = this.Form.LogisticsCode;
                this.AddForm.LogisticsId = this.Form.LogisticsId * 1;
                this.AddForm.Remark = this.Form.Remark;
                this.SendGood = this.Form.CurrentSendStatus;
              });
            });
          // LoadThirdStockOutByIdForUpdate(para).then(res => {
          //   util.doResult(this, res, () => {
          //     this.Form = res.data.Data;
          //     this.AddForm.LogisticsCode = this.Form.LogisticsCode;
          //     this.AddForm.LogisticsId = this.Form.LogisticsId * 1;
          //     this.AddForm.Remark = this.Form.Remark;
          //     this.SendGood = this.Form.CurrentSendStatus;
          //   });
          // });
        }
      });
    });
  }
};


// WEBPACK FOOTER //
// ./src/pages/Family/SendNotice/CreateStockOut/vm.js